import { render, staticRenderFns } from "./AssignAnalysts.vue?vue&type=template&id=6a35b3d7&scoped=true"
import script from "./AssignAnalysts.vue?vue&type=script&lang=js"
export * from "./AssignAnalysts.vue?vue&type=script&lang=js"
import style0 from "./AssignAnalysts.vue?vue&type=style&index=0&id=6a35b3d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a35b3d7",
  null
  
)

export default component.exports